import { render, staticRenderFns } from "./AccountOrderDetailsBackorderedItem.vue?vue&type=template&id=5ce23e2e&"
import script from "./AccountOrderDetailsBackorderedItem.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsBackorderedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports